import { environment } from '../../../../environments/environment'

export function getCurrentUserId(): string {
  const token = localStorage.getItem(environment.token)
  if (!token) return ''
  const payload = JSON.parse(atob(token.split('.')[1]))
  return payload._id ?? ''
}
